import { useEffect, useState } from "react";
import { CtaButton } from "./CtaButton";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../content";
import { Logo } from "./Logo";

const links = [
  { href: "#digital", label: "Digital" },
  { href: "#handcraft", label: "Handcraft" },
  { href: "#process", label: "Process" },
];

export function Nav() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <>
      <header className="fixed inset-x-0 top-4 z-50 flex justify-center px-4">
        <nav
          aria-label="Main"
          className="flex h-14 w-full max-w-3xl items-center justify-between gap-3 rounded-full md:gap-6 bg-coal/70 pl-2 pr-1.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] ring-1 ring-white/10 backdrop-blur-xl"
        >
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap font-display text-xs font-extrabold sm:gap-3 sm:text-sm uppercase tracking-tight">
            <Logo className="h-10 w-10" />
            Miss Stabbypants
          </a>

          <ul className="hidden items-center gap-7 text-sm text-smoke md:flex">
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="transition-colors duration-500 ease-heavy hover:text-bone">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="hidden md:block">
            <CtaButton />
          </div>

          <button
            type="button"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            aria-controls="mobile-menu"
            onClick={() => setOpen((o) => !o)}
            className="relative h-11 w-11 shrink-0 rounded-full bg-white/5 ring-1 ring-white/10 transition-transform duration-500 ease-heavy active:scale-95 md:hidden"
          >
            <span
              className={`absolute left-1/2 top-1/2 h-px w-4 -translate-x-1/2 bg-bone transition-transform duration-500 ease-heavy ${
                open ? "rotate-45" : "-translate-y-[4px]"
              }`}
            />
            <span
              className={`absolute left-1/2 top-1/2 h-px w-4 -translate-x-1/2 bg-bone transition-transform duration-500 ease-heavy ${
                open ? "-rotate-45" : "translate-y-[4px]"
              }`}
            />
          </button>
        </nav>
      </header>

      <div
        id="mobile-menu"
        inert={!open}
        className={`fixed inset-0 z-40 flex flex-col justify-between bg-ink/90 px-6 pb-10 pt-32 backdrop-blur-2xl transition-opacity duration-500 ease-heavy md:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <ul className="space-y-2">
          {links.map((l, i) => (
            <li key={l.href} className="overflow-hidden">
              <a
                href={l.href}
                onClick={() => setOpen(false)}
                style={{ transitionDelay: open ? `${100 + i * 70}ms` : "0ms" }}
                className={`block font-display text-5xl font-extrabold uppercase tracking-tighter transition-[translate,opacity] duration-700 ease-heavy ${
                  open ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="flex flex-col items-start gap-5">
          <CtaButton />
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center text-sm text-smoke">
            {INSTAGRAM_HANDLE}
          </a>
        </div>
      </div>
    </>
  );
}
